import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as S from '../SrpLeftBlock/SrpLeftBlock.styles';
import FiltersBlock from './../FiltersBlock/FiltersBlock';
import { journeyTypeSelector } from './../../../SEOContainer/Common/redux/selectors';
import { getInitSelectedFilters } from './../../../SEOContainer/Common/utils';
import { addRemoveArrayOperation } from './../../../SEOContainer/Common/utils';
import { commonSelector } from './../../../SEOContainer/Common/redux/selectors'
import { trackFilterEvent } from '../../../utils/Omniture';

const SrpLeftBlock = props => {
  const dispatch = useDispatch();
  const journeyType = useSelector(journeyTypeSelector);
  const [activeSearchVal, setActiveSearchVal] = useState({});
  const [activeSearchType, setActiveSearchType] = useState('');
  const { selectedFilters, setSelectedFilters } = props;
  const commonData = useSelector(commonSelector);
  const { filterStr, operator_id, operator_name, pageType } = commonData
  const { filters, filterCollapse, operatorDisplayName } = props;

  useEffect(() => {
    // to reset the filter on update search 
    let filterOperators = {}
    if (pageType === 'route_operator') {
      filterOperators[operator_id] = operatorDisplayName || operator_name;
    }
    // setSelectedFilters(Object.assign({}, getInitSelectedFilters({filterStr,operators:filterOperators})));
  }, [])
  const {
    boardingPoints,
    droppingPoints,
    operators,
    amenities,
    collapsedFilter,
    collapsedFilterItemCount,
    popularFilters,
  } = filters;

  return (
    <S.SrpLeftBlockLayoutDiv className="filterSection">
      <FiltersBlock
        boardingPoints={
          activeSearchType === 'boardingPoint' || activeSearchVal['boardingPoint']
            ? getFilteredPoints(boardingPoints[journeyType], activeSearchVal, 'boardingPoint')
            : boardingPoints[journeyType]
        }
        droppingPoints={
          activeSearchType === 'droppingPoint' || activeSearchVal['droppingPoint']
            ? getFilteredPoints(droppingPoints[journeyType], activeSearchVal, 'droppingPoint')
            : droppingPoints[journeyType]
        }
        operators={
          activeSearchType === 'operator' || activeSearchVal['operator']
            ? getFilteredOperators(operators[journeyType], activeSearchVal, 'operator')
            : operators[journeyType]
        }
        resetActiveSearchVal={(val) => {
          if (val) {
            let obj = Object.assign({}, activeSearchVal);
            obj[val] = ''
            setActiveSearchVal(obj);
          }
        }}
        amenities={amenities}
        popularFilters={popularFilters}
        showAllBoardingPoints={!(collapsedFilter.indexOf('boardingPoint') !== -1)}
        showAllDroppingPoints={!(collapsedFilter.indexOf('droppingPoint') !== -1)}
        showAllOperators={!(collapsedFilter.indexOf('operator') !== -1)}
        showAllAmenities={!(collapsedFilter.indexOf('amenities') !== -1)}
        itemDisplayCount={collapsedFilterItemCount}
        onFiltersReset={evt => {
          const val = evt.target.dataset.val;
          let filters = Object.assign({}, selectedFilters);
          if (val === 'resetAll') {
            setSelectedFilters(Object.assign({}, getInitSelectedFilters({})));
          } else {
            filters[val] = [];
            setSelectedFilters(filters);
          }
        }}
        onFilterSelect={(selectedFilterType, selectedValue, selectedFiltersName?: string) => {
          let filters = Object.assign({}, selectedFilters);
          let selected = true;
          if (selectedFilterType === 'operator') {
            if (filters[selectedFilterType][selectedValue]) {
              selected = false;
              delete filters[selectedFilterType][selectedValue];
            } else {
              filters[selectedFilterType][selectedValue] = selectedFiltersName;
            }
          } else {
            if (filters[selectedFilterType].indexOf(selectedValue) !== -1) {
              selected = false;
            }
            filters[selectedFilterType] = addRemoveArrayOperation(
              filters[selectedFilterType],
              selectedValue,
            );
          }
          trackFilterEvent({selectedFilterType,selectedFilters,type:"select"});
          props.onClickCb({ isFilter: true, filters })
        }}
        onFilterCollapse={filterCollapsedEle => {
          const val = filterCollapsedEle.target.dataset.val;
          dispatch(filterCollapse(val));
        }}
        activeSearchVal={activeSearchVal}
        activeSearchType={activeSearchType}
        onSearchTypeValChange={evt => {
          const ele = evt.target;
          if (ele) {
            let obj = Object.assign({}, activeSearchVal);
            obj[ele.dataset.val] = ele.value
            setActiveSearchVal(obj);
          }
        }}
        onInputFocus={evt => {

          const ele = evt.target;
          if (ele) {
            let obj = Object.assign({}, activeSearchVal);
            obj[ele.dataset.val] = ele.value
            setActiveSearchVal(obj);
            setActiveSearchType(ele.dataset.val);
          }
        }}
        onBlur={evt => {
          const ele = evt.target;

          if (ele) {
            //if we pass empty string in input value then it ignores and not changing the state of input box so need to set manually
            //    ele.value = '';
          }
        }}
        selectedFilters={selectedFilters}
      />
    </S.SrpLeftBlockLayoutDiv>
  );
};

export default SrpLeftBlock;

function getFilteredPoints(data, activeSearchVal, activeSearchType) {
  if (!activeSearchVal[activeSearchType]) {
    return data;
  }
  const searchStr = activeSearchVal[activeSearchType].toLowerCase();
  const filteredResults = [];
  for (let i in data) {
    if (data[i].toLowerCase().indexOf(searchStr) !== -1) {
      filteredResults.push(data[i]);
    }
  }
  return filteredResults;
}

function getFilteredOperators(data, activeSearchVal, activeSearchType) {
  if (!activeSearchVal[activeSearchType]) {
    return data;
  }
  const searchStr = activeSearchVal[activeSearchType].toLowerCase();
  const filteredResults = [];
  for (let i in data) {
    if (data[i].name.toLowerCase().indexOf(searchStr) !== -1) {
      filteredResults.push(data[i]);
    }
  }
  return filteredResults;
}
